import { usePanorama as usePanoramaGeneric } from '@wix/package-picker-shared';
export const useEclipsePanorama = () => {
  return usePanoramaGeneric();
};
//# sourceMappingURL=useEclipsePanorama.js.map